import { STEPS } from "../constants";

import { ArrowRight, Loader2, Undo2Icon } from "lucide-react";

const getBackButtonConfig = (setStep, isProcessing, isSubmitting, file) => ({
  disabled: (step) =>
    step === STEPS.FILE_UPLOAD || isProcessing || isSubmitting,
  onClick: (step) => {
    if (step === STEPS.COLUMN_MAPPING) return () => setStep(STEPS.FILE_UPLOAD);
    if (step === STEPS.DATA_VALIDATION) {
      return () => {
        if (file) {
          setStep(STEPS.COLUMN_MAPPING);
        } else {
          setStep(STEPS.FILE_UPLOAD);
        }
      };
    }
    return () => {};
  },
  text: (step) => {
    if (step === STEPS.COLUMN_MAPPING) return "Dosyayı Değiştir";
    if (step === STEPS.DATA_VALIDATION) return "Geri Dön";
    return "";
  },
  icon: Undo2Icon,
});

const getForwardButtonConfig = ({
  file,
  isProcessing,
  isSubmitting,
  isMappingComplete,
  processData,
  handleSubmit,
  setStep,
}) => ({
  [STEPS.FILE_UPLOAD]: {
    onClick: file
      ? () => setStep(STEPS.COLUMN_MAPPING)
      : () => setStep(STEPS.DATA_VALIDATION),
    disabled: isProcessing,
    text: "İlerle",
    Icon: ArrowRight,
    loading: isProcessing,
    primary: true,
  },
  [STEPS.COLUMN_MAPPING]: {
    onClick: processData,
    disabled: !isMappingComplete || isProcessing,
    text: "İlerle",
    Icon: ArrowRight,
    loading: isProcessing,
    primary: true,
  },
  [STEPS.DATA_VALIDATION]: {
    onClick: handleSubmit,
    disabled: isSubmitting,
    text: isSubmitting ? "Yükleniyor..." : "Yükle",
    Icon: isSubmitting ? Loader2 : ArrowRight,
    loading: isSubmitting,
    primary: true,
  },
});

export const getNavigationConfig = (props) => {
  const { setStep, isProcessing, isSubmitting, file } = props;

  return {
    backButton: getBackButtonConfig(setStep, isProcessing, isSubmitting, file),
    forwardButton: getForwardButtonConfig(props),
  };
};
